<template>
  <v-dialog width="700px" v-model="dialog">
    <template v-slot:activator="{ on }">
      <span v-on="on" class="pointer">
        <slot></slot>
      </span>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Push message</span>
        <div class="dialog-closeBtn" @click="dialog = false">
          <v-icon left>mdi-close</v-icon>
        </div>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="form">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  clear-icon="mdi-close"
                  clearable
                  outlined
                  label="Title*"
                  hint="enter title"
                  required
                  v-model="title"
                  :error-messages="titleErrors"
                  @input="$v.title.$touch()"
                  @blur="$v.title.$touch()"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="12" class="pb-0">
                <v-textarea
                  outlined
                  label="Body*"
                  v-model="body"
                  :error-messages="bodyErrors"
                  @input="$v.body.$touch()"
                  @blur="$v.body.$touch()"
                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="12">
                <v-select
                  outlined
                  label="Areas to Message"
                  multiple
                  chips
                  deletable-chips
                  hint="leave blank to messages all drivers"
                  persistent-hint
                  v-model="area_ids"
                  :items="areasList"
                  item-text="name"
                  item-value="id"
                  @change="onChangeArea"
                ></v-select>
              </v-col>

              <v-col cols="12" sm="12">
                <v-autocomplete
                  outlined
                  label="Restaurants to Message"
                  multiple
                  clear-icon="mdi-close"
                  clearable
                  chips
                  deletable-chips
                  hint="leave blank to messages all drivers"
                  persistent-hint
                  :items="restaurantsListSearched"
                  v-model="restaurant_ids"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="12">
                <v-select
                  outlined
                  clear-icon="mdi-close"
                  clearable
                  label="Notify Active/Inactive Drivers"
                  hint="leave blank to messages all drivers"
                  persistent-hint
                  v-model="notify_status"
                  :items="notifyStatusList"
                  item-text="name"
                  item-value="id"
                ></v-select>
              </v-col>

              <v-col cols="12" sm="12">
                <v-autocomplete
                  outlined
                  label="Drivers to Message"
                  multiple
                  clear-icon="mdi-close"
                  clearable
                  chips
                  deletable-chips
                  hint="leave blank to messages all drivers"
                  persistent-hint
                  :items="driverListSearched"
                  v-model="driver_ids"
                  item-text="full_name"
                  item-value="id"
                ></v-autocomplete>
              </v-col>

            </v-row>

            <div class="d-flex justify-center">
              <v-btn
                depressed
                class="mr-4 primary"
                :disabled="this.$v.$invalid || localLoading"
                @click="submit"
                :loading="localLoading"
              >
                <v-icon left>mdi-cellphone-message</v-icon>
                Send Message(s)
              </v-btn>
              <v-btn
                class="warning"
                depressed
                @click="cancel"
                :loading="localLoading"
              >
                <v-icon left>mdi-cancel</v-icon>
                Cancel
              </v-btn>
            </div>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  required,
  maxLength,
} from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import * as _ from "lodash";

const DRIVER_STATUS_ACTIVE = 10;
const DRIVER_STATUS_INACTIVE = 20;
// const DRIVER_STATUS_REGISTRED = 30;

export default {
  mixins: [validationMixin],
  name: "SendPushMessage",
  validations: {
    title: { required, maxLength: maxLength(55) },
    body: { required, maxLength: maxLength(255) }
  },
  data: () => ({
    dialog: false,
    localLoading: false,
    area_ids: [],
    restaurant_ids: [],
    driver_ids: [],
    notifyStatusList: [{
        id: DRIVER_STATUS_ACTIVE,
        name: 'Active only'
      }, {
        id: DRIVER_STATUS_INACTIVE,
        name: 'Inactive only'
      // }, {
      //   id: 30,
      //   name: 'Registred oly'
    }],
    notify_status: void 0,
    title: '',
    body: '',
  }),
  computed: {
    ...mapGetters({
      area_list: 'areas',
      restaurant_list: 'restaurants',
      driver_list: 'drivers',
    }),
    titleErrors () {
      const errors = []
      if (!this.$v.title.$dirty) return errors
      !this.$v.title.maxLength && errors.push('Title must be at most 55 characters long')
      !this.$v.title.required && errors.push('Title is required.')
      return errors
    },
    bodyErrors () {
      const errors = []
      if (!this.$v.body.$dirty) return errors
      !this.$v.body.maxLength && errors.push('Body must be at most 255 characters long')
      !this.$v.body.required && errors.push('Body is required.')
      return errors
    },
    areasList() {
      return this.area_list;
    },
    restaurantsListSearched() {
      if (this.area_ids.length == 0) {
        return [];
      }

      return _.filter(
        this.restaurant_list,
        (p) => this.area_ids.indexOf(+p.area_id) !== -1
      );
    },
    driverListSearched() {
      return _.filter(this.driver_list, driver => {
          if (driver.area_ids.length == 0) {
              return true; // driver not assigned to any area
          }

          let driver_area_ids = _.map(driver.area_ids, p => p.area_id);
          if (this.area_ids.length > 0 && _.intersection(driver_area_ids, this.area_ids).length == 0) {
            return false;
          }

          // check driver assigned to restaurant
          if (driver.restaurant_ids.length == 0) {
              return true; // driver not assigned to any restaurant
          }

          let driver_restaurant_ids = _.map(driver.restaurant_ids, p => p.restaurant_id);
          if (this.restaurant_ids.length > 0 && _.intersection(driver_restaurant_ids, this.restaurant_ids).length == 0) {
            return false;
          }

          if (this.notify_status && this.notify_status != driver.status) {
            return false;
          }

          return true;
      });
    },
  },
  created() {
    // --
  },
  mounted() {
    Promise.all([
        this.$store.dispatch('fetchLocations'), // for dialog
        this.$store.dispatch('fetchDrivers'), // for dialog
        // this.$store.dispatch('fetchRestaurants'), //? double loadin
        // this.$store.dispatch('fetchAreas') //? double loadin
    ]).then(() => {
      // --
    });
  },

  methods: {
    onChangeArea(/*values*/) {
      let areas_restaurants = _.map(this.restaurantsListSearched, (p) => p.id);

      // clear selected restaurants on change area
      this.restaurant_ids = _.intersection(
        areas_restaurants,
        this.restaurant_ids
      );
    },
    onChangeRestaurant(/*values*/) {
      // debugger;
    },
    onChangeDriver(/*values*/) {
      // debugger;
    },
    cancel() {
      this.dialog = false;
    },
    submit() {
      this.localLoading = true;
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const message_data = {
          title: this.title,
          body: this.body,
          area_ids: this.area_ids,
          restaurant_ids: this.restaurant_ids,
          notify_status: this.notify_status,
          driver_ids: this.driver_ids,
        };

        this.$store
          .dispatch("messageDriver", message_data)
          .then(() => {
            this.dialog = false;
          })
          .catch((error) => {
            let errors = error.response;
            this.$store.dispatch("setError", errors[Object.keys(errors)[0]][0]);
          })
          .finally(() => {
            this.localLoading = false;
          });
      }
    },
  },
};
</script>

<style scoped>
</style>